var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("H1", { staticClass: "pageTitle" }, [_vm._v("CHECKOUT")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "top60", attrs: { id: "checkoutTableDiv" } },
          [
            _c("cart"),
            _vm._v(" "),
            _c("div", { staticClass: "has-text-right" }, [
              _c(
                "button",
                {
                  staticClass: "button is-warning top20",
                  attrs: { disabled: _vm.$root.cartContents == 0 },
                  on: { click: _vm.proceed }
                },
                [_vm._v("Proceed to Payment")]
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("br"),
        _c("br")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47c45a2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c45a2c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Checkout.vue
// module id = null
// module chunks = 